namespace GeniuzPOS.Member {
    export namespace MbReport_01_Dt_Service {
        export const baseUrl = 'Member/MbReport_01_Dt_';

        export declare function Create(request: Serenity.SaveRequest<MbReport_01_Dt_Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MbReport_01_Dt_Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MbReport_01_Dt_Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MbReport_01_Dt_Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Member/MbReport_01_Dt_/Create",
            Update = "Member/MbReport_01_Dt_/Update",
            Delete = "Member/MbReport_01_Dt_/Delete",
            Retrieve = "Member/MbReport_01_Dt_/Retrieve",
            List = "Member/MbReport_01_Dt_/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>MbReport_01_Dt_Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
